import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faCircleExclamation, faSpinner, faCheckCircle, faKey } from '@fortawesome/free-solid-svg-icons';

export const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) { setError('Passwords do not match'); return; }
    setLoading(true);
    setError('');
    try {
      const response = await fetch('/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password })
      });
      if (response.ok) {
        setSuccess(true);
        setTimeout(() => navigate('/login'), 2000);
      } else {
        const data = await response.json();
        setError(data.message || 'Failed to reset password');
      }
    } catch { setError('Network error. Please try again.'); }
    finally { setLoading(false); }
  };

  return (
    <>
      <SEO title="Reset Password | GHLWA" canonical="https://app.ghlwa.com/reset-password" />
      <div className="min-h-screen flex">
        <div className="auth-left-panel">
          <div className="absolute top-[-80px] right-[-80px] w-72 h-72 rounded-full opacity-10" style={{ background: '#6366f1' }} />
          <div className="absolute bottom-[-60px] left-[-60px] w-56 h-56 rounded-full opacity-10" style={{ background: '#f59e0b' }} />
          <div className="relative z-10 flex flex-col items-center text-center">
            <img src="/ghlwa.png" alt="GHLWA Logo" className="h-24 w-auto mb-8 drop-shadow-xl" />
            <h1 className="text-4xl font-extrabold text-white mb-3 tracking-tight">GHLWA</h1>
            <p className="text-indigo-200 text-lg max-w-xs leading-relaxed">
              Seamless WhatsApp messaging for your GHL locations
            </p>
          </div>
        </div>
        <div className="auth-right-panel">
          <div className="w-full max-w-md">
            <div className="flex justify-center mb-8 lg:hidden">
              <img src="/ghlwa.png" alt="GHLWA" className="h-16 w-auto" />
            </div>
            {success ? (
              <div className="text-center">
                <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-5">
                  <FontAwesomeIcon icon={faCheckCircle} className="text-primary-600 text-3xl" />
                </div>
                <h2 className="text-2xl font-bold text-secondary-900 mb-3">Password reset!</h2>
                <p className="text-secondary-500">Redirecting you to login...</p>
              </div>
            ) : (
              <>
                <h2 className="text-3xl font-extrabold text-secondary-900 mb-2">Set new password</h2>
                <p className="text-secondary-500 mb-8">Enter your new password below.</p>
                {error && (
                  <div className="mb-5 flex items-center gap-2 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-xl text-sm">
                    <FontAwesomeIcon icon={faCircleExclamation} />{error}
                  </div>
                )}
                <form className="space-y-5" onSubmit={handleSubmit}>
                  <div>
                    <label htmlFor="password" className="block text-sm font-medium text-secondary-700 mb-1.5">New Password</label>
                    <div className="relative">
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3.5 text-secondary-400 pointer-events-none"><FontAwesomeIcon icon={faLock} className="text-sm" /></span>
                      <input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-field pl-10" placeholder="........" />
                    </div>
                  </div>
                  <div>
                    <label htmlFor="confirmPassword" className="block text-sm font-medium text-secondary-700 mb-1.5">Confirm Password</label>
                    <div className="relative">
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3.5 text-secondary-400 pointer-events-none"><FontAwesomeIcon icon={faLock} className="text-sm" /></span>
                      <input id="confirmPassword" type="password" required value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className="input-field pl-10" placeholder="........" />
                    </div>
                  </div>
                  <button type="submit" disabled={loading} className="btn-primary w-full flex items-center justify-center gap-2 py-3 text-base disabled:opacity-50">
                    {loading ? (<><FontAwesomeIcon icon={faSpinner} className="animate-spin" /> Resetting...</>) : (<><FontAwesomeIcon icon={faKey} /> Reset password</>)}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
